import type { APIClient } from '@src/shared/api';
import { prefetchQuery } from '@src/shared/query';
import { absenceTimelineUrl } from './constants';
import type { AbsenceQueryParams } from './useAbsences';

/**
 * Warm the query the calendar actually reads.
 *
 * The timeline, not the plain daily list: that is where the page gets its rows,
 * its blocks and its entries, and it is keyed on its own path -- so prefetching
 * the list left a request paid for and nothing warmed.
 */
export default function prefetchAbsences(
  client: APIClient,
  queryParams: AbsenceQueryParams = {},
) {
  return prefetchQuery(absenceTimelineUrl, client, { queryParams });
}
